import React from "react";

import { Filter } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { CommodityCategory } from "entities/CommodityCategory";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { NumberInputEx } from "components/inputs";


export const CommoditiesFilter = ({ companySource, hasCompanyFilter, ...props }) => (
	<Filter {...props}>
		<NumberInputEx source="id" key={"id"} parse={(elem) => (elem ? [elem] : [])} />
		<TextInputEx source="name" />
		<SelectEnumInput  source="category" enumName="commodity-category" enumObj={CommodityCategory} />
	</Filter>
);
